import React, { useState, useEffect, useRef } from 'react';
import { Container, Textarea, TextInput, Select } from 'react-materialize';
import Button from '../atoms/button.jsx';
import { Label } from '../atoms/label.jsx';
import Row from '../organism/row.jsx';
import { COLOR, SIZE, KEY, LABEL, SCREEN_MEDIA, FONT_FAMILY } from '../../utils/constants.js';
import { useDecorationTypes } from '../hooks/useDecorationTypes';
import LoadingSpinner from '../organism/spinner';
import { useDecorationPost } from '../hooks/useDecorationPost.js';
import { getDecorationTypesMap, getUpdatedDecorationTypesMap } from '../../utils/managersearch';

const BodyDecorationPost = () => {

    const fetchedDecorationTypeList = useDecorationTypes();
    const [decorationTyesMap, setDecorationTypesMap] = useState();
    const [isLoading, setIsLoading] = useState(true)
    const [isFormLoading, setIsFormLoading] = useState(false)
    const [formData, setFormData] = useState(null);

    const decorationPostResult = useDecorationPost(isFormLoading, formData)

    useEffect(() => {
        if (fetchedDecorationTypeList && fetchedDecorationTypeList.length > 0) {
            setDecorationTypesMap(getDecorationTypesMap(fetchedDecorationTypeList))
        }
    }, [fetchedDecorationTypeList])

    useEffect(() => {
        if (decorationTyesMap && decorationTyesMap.length > 0) {
            setIsLoading(false)
        }
    }, [decorationTyesMap])

    useEffect(() => {
        if (decorationPostResult && decorationPostResult?.success !== undefined) {
            setIsFormLoading(false)
            if (decorationPostResult.success) {
                window.M.toast({
                    html: 'Upload successful!',
                    classes: 'rounded green',
                    displayLength: 3000
                })
            } else {
                window.M.toast({
                    html: 'Upload error!',
                    classes: 'red',
                    displayLength: 3000
                })
            }
        }
    }, [decorationPostResult])

    const onTypeSelected = (e) => {
        e.preventDefault();
        setDecorationTypesMap(getUpdatedDecorationTypesMap(e, decorationTyesMap, fetchedDecorationTypeList))
    }

    const handleDecorationPost = (e) => {
        e.preventDefault();
        const data = new FormData(e.currentTarget)
        setFormData(data);
        setIsFormLoading(true)
    }

    if (isLoading || isFormLoading) return <LoadingSpinner/>

    return(
        <Container>
            <Row>
                <form onSubmit={ handleDecorationPost }>
                <TextInput
                    label='Upload WebP'
                    type='file'
                    name='image'
                    accept="image/webp, image/jpeg, image/png" // Limits selection to WebP
                    onChange={ () => {} }
                    />
                <Select
                    id={`score`}
                    name={`score`}
                    multiple={false}
                    onChange={ () => {} }
                    options={{
                        dropdownOptions: {
                        closeOnClick: true,
                        }
                    }}>
                    <option value='' disabled selected>{`Score`}</option>
                    {/* Generate 0 to 20 on the fly and map them to elements */}
                    {
                        Array.from({ length: 21 }, (v, i) => (
                            <option key={i} value={i*5}>
                                {(i*5)/10}
                            </option>
                        ))
                    }
                </Select>
                {
                    decorationTyesMap.map((decorationTypeLv, selectIndex) => {
                        let levelIndex = selectIndex+1;
                        return (
                            <Select
                                id={`selectTypeLv${ levelIndex }`}
                                name={`lv${levelIndex}`}
                                multiple={false}
                                disabled = {!decorationTypeLv.isEnabled}
                                onChange={ onTypeSelected }
                                options={{
                                    dropdownOptions: {
                                    closeOnClick: true,
                                    }
                                }}
                                >
                                <option value='' disabled selected>{`Type lv${levelIndex}`}</option>
                                {
                                    decorationTypeLv.typeList.map((lvxOption, optionIndex) =>
                                        <option value={lvxOption.id}>
                                            { lvxOption.title }
                                        </option>
                                    )
                                }
                            </Select>
                        )
                    })
                }
                <Textarea
                    id="description"
                    name="description"
                    placeholder="Description"
                    />
                <Button
                    type='submit'
                    width='120px'
                    height='46px'
                    bg_color={ COLOR.black }
                    margin='10px 0 0 0'
                    float='right'
                    onChange={ () => {} }>
                    <Label
                        text_color={ COLOR.white }
                        text_size={SIZE.subtitle}
                        font_family={FONT_FAMILY.avenirMedium}
                        margin='auto'>
                        {LABEL.send}
                    </Label>
                </Button>
                </form>
            </Row>
        </Container>
    )
};

export default BodyDecorationPost;